export default __webpack_public_path__ + "static/LeituraTwo-BlackItalic-a9d76d2db54fc9e0dcb4192a134639c8.woff";